import React from 'react';
import { Skeleton, Tooltip } from 'gatorcomponents';
import * as Styles from './CardButton.styles';

const CardButton = ({
  show,
  description,
  value,
  type = 'none',
  isSelected = false,
  icon,
  twoFactorAuthLocale,
  isLoadingMethods,
  methodData,
  onClick,
  testId = 'card-button',
}) => {
  const handleClick = (event) => {
    if (!methodData.active) {
      return;
    }
    onClick && onClick(type, event);
  };

  if (!show) {
    return null;
  }

  if (isLoadingMethods) {
    return (
      <Skeleton variant="rectangle" width="320px" height="98px" />
    );
  }

  const isDisabled = methodData ? !methodData.active : true;
  const noAttemptsLeft = methodData ? methodData.left === 0 : false;

  const IconColor = isDisabled ? 'lowLight' : 'lowPure';

  const tooltipContent = noAttemptsLeft
    ? twoFactorAuthLocale.chooseMethodModal.tooltip.noAttemptsLeft
    : twoFactorAuthLocale.chooseMethodModal.tooltip.notConfirmedPhone;

  let valuePlaceholder = null;
  if (isDisabled) {
    valuePlaceholder = noAttemptsLeft
      ? twoFactorAuthLocale.chooseMethodModal.noAttemptsLeftValue
      : twoFactorAuthLocale.chooseMethodModal.notConfirmedPhoneValue;
  }

  return (
    <Tooltip
      content={tooltipContent}
      preferredPosition="bottomLeft"
      disabled={!isDisabled}
      width={215}
    >
      <Styles.CardWrapper
        onClick={event => handleClick(event)}
        data-testid={testId}
        isSelected={isSelected}
        isDisabled={isDisabled}
      >
        <Styles.IconWrapper>
          {icon(IconColor)}
        </Styles.IconWrapper>
        <Styles.InfoWrapper>
          <Styles.Description isDisabled={isDisabled}>{description}</Styles.Description>

          {value && (
            <Styles.Value data-testid={`card-button__${type}--value`} isDisabled={isDisabled}>
              {valuePlaceholder || value}
            </Styles.Value>
          )}
        </Styles.InfoWrapper>
      </Styles.CardWrapper>
    </Tooltip>
  );
};

export default CardButton;
